// export type TransitType = 'weekly' | 'monthly';
// export type WeekType = 'current' | 'next';

// export const getTransitTimestamp = (type: TransitType, weekType: WeekType = 'current'): string => {
//   // ✅ Always work in IST
//   const now = new Date();
//   const istNow = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

//   let targetDate: Date;

//   if (type === 'weekly') {
//     const day = istNow.getDay(); // IST day
//     targetDate = new Date(
//       istNow.getFullYear(),
//       istNow.getMonth(),
//       istNow.getDate() - day,
//       0,
//       0,
//       0,
//       0
//     );

//     // ✅ Move to next week if needed
//     if (weekType === 'next') {
//       targetDate.setDate(targetDate.getDate() + 7);
//     }
//   } else {
//     // Monthly: first day of month IST
//     targetDate = new Date(istNow.getFullYear(), istNow.getMonth(), 1, 0, 0, 0, 0);
//   }

//   return targetDate.toISOString(); // UTC-safe ISO
// };

export type TransitType = 'weekly' | 'monthly';
export type WeekType = 'current' | 'next';

export const getTransitTimestamp = (type: TransitType, weekType: WeekType = 'current'): string => {
  const now = new Date();

  // Get IST offset (UTC+5:30 = 330 minutes)
  const istOffset = 5.5 * 60 * 60 * 1000;
  const istTime = new Date(now.getTime() + istOffset);

  let targetDate: Date;

  if (type === 'weekly') {
    const day = istTime.getUTCDay();

    targetDate = new Date(istTime);
    targetDate.setUTCDate(istTime.getUTCDate() - day);
    targetDate.setUTCHours(0, 0, 0, 0);

    if (weekType === 'next') {
      targetDate.setUTCDate(targetDate.getUTCDate() + 7);
    }
  } else {
    // Monthly: first day of current month in IST
    targetDate = new Date(istTime);
    targetDate.setUTCDate(1);
    targetDate.setUTCHours(0, 0, 0, 0);
  }

  // Convert back to actual UTC by subtracting IST offset
  return new Date(targetDate.getTime() - istOffset).toISOString();
};
